module.exports = __webpack_public_path__ + "static/media/about_you_mobile.e2d42ba2.svg";